/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';

Swiper.use();
export function slider() {
    const latestArticlesSliderSelector = ".articles-list__items-slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }


    const init = function () {
        // Latest Articles sliders
        const latestArticlesSliders = [];
        const latestArticlesSlidersElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (latestArticlesSlidersElements) {
            latestArticlesSlidersElements.forEach(slider => {
                const swiperInstance = new Swiper(slider, {
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    },
                });

                latestArticlesSliders.push(swiperInstance);
            });
        }
    }

    init();

}
